module.exports = __webpack_public_path__ + "expedia.png?cc5126e915420cff43d8066b3fd9114b";